import LegalDoc, { LegalSection, LegalList } from "@/components/LegalDoc";

const PrivacyPolicy = () => (
  <LegalDoc title="Privacy Policy" updated="October 1st, 2026">
    <p className="text-base text-ink/80 leading-relaxed">
      This policy explains how Responsible Charity Society (the Society, we, us), the registered Indian
      NGO that runs AimGame, collects, uses and protects personal information on aimgame.org. By using
      this site or donating, you accept this policy.
    </p>

    <LegalSection title="What we collect">
      <LegalList
        items={[
          "Donors: full name, address, PAN No., email, phone, the amount, date and payment reference, and whether you want your name kept off public lists.",
          "Bank transfer requests and transfer reports: the same details, plus your transaction reference and an optional screenshot.",
          "Enquiry forms (Let's Talk, CSR inquiry, Giving Desk): name, email, phone, organization, role and message.",
          "Website data: pages viewed and device and browser information, collected through cookies and analytics with your consent where required.",
        ]}
      />
      <p>
        We never collect your card number, UPI PIN or net-banking login. Those are entered on Razorpay's
        secure payment screen.
      </p>
    </LegalSection>

    <LegalSection title="How we use it">
      <LegalList
        items={[
          "To issue receipts and Form 10BE certificates.",
          "To meet tax and legal reporting duties, including our annual donation statement.",
          "To record and match donations, including bank transfers and cheques.",
          "To reply to your enquiries and, only if you agree, to send updates about our work.",
          "To keep the site secure and working well.",
        ]}
      />
    </LegalSection>

    <LegalSection title="Payments">
      <p>
        Card, UPI and net-banking payments are processed by Razorpay, a payment gateway. Razorpay
        receives the details needed to complete your payment and handles them under its own privacy
        policy.
      </p>
    </LegalSection>

    <LegalSection title="Who we share it with">
      <p>
        We do not sell your information. We share it only with Razorpay, to process payments; our
        website, email and hosting providers, to run the site; our auditors and accountants, for
        records and filings; and the Income Tax Department and other authorities, when the law requires.
      </p>
    </LegalSection>

    <LegalSection title="PAN No. and address">
      <p>
        Indian tax law requires us to record every donor's name and address and to report each donor's
        PAN No. We store these securely, limit access to the staff who need them for receipts and
        reporting, and never send them in routine emails. If you ask us not to list your name publicly,
        we will not, but we must still keep your details privately.
      </p>
    </LegalSection>

    <LegalSection title="How long we keep it">
      <p>
        We keep donor records for as long as Indian tax, audit and charity rules require, and enquiry
        messages for as long as needed to answer them and keep a fair record.
      </p>
    </LegalSection>

    <LegalSection title="Security">
      <p>
        Our site uses HTTPS. We use access controls, secure storage and regular backups, and we limit
        who can see donor information.
      </p>
    </LegalSection>

    <LegalSection title="Cookies">
      <p>
        We use cookies that the site needs to work and, with your consent, cookies that help us
        understand how the site is used. You can change your choice through the cookie banner or your
        browser settings.
      </p>
    </LegalSection>

    <LegalSection title="Photos and names of scholars">
      <p>We publish photos and names of scholars and graduates only with consent.</p>
    </LegalSection>

    <LegalSection title="Your choices">
      <p>
        You can ask to see, correct or delete your information, or to stop receiving updates, by writing
        to info@responsiblecharity.org. Where the law requires us to keep donor records, we will keep
        what is required and delete the rest.
      </p>
    </LegalSection>

    <LegalSection title="Contact and changes">
      <p>
        Responsible Charity Society, 22 Shaktigarh, Jadavpur, Kolkata, West Bengal 700032, Phone:
        03340048442, info@responsiblecharity.org. We may update this policy, and the date below shows
        the latest version.
      </p>
    </LegalSection>
  </LegalDoc>
);

export default PrivacyPolicy;
